import type {ExportItemState} from './components/export-menu-item/export-menu-item.types';

export {ExportItemState} from './components/export-menu-item/export-menu-item.types';

export enum ExportMenuOption {
  COPY_HTML = 'copy-html',
  COPY_AS_TEXT = 'copy-as-text',
  DOWNLOAD_HTML = 'download-html',
}

export const EXPORT_STATE_RESET_DELAY_MS = 2000;

export const GETTY_BUY_DESIGN_PATH = 'posterbuilder/load';

export type ExportStateMap = Record<ExportMenuOption, ExportItemState>;
